module.exports = __webpack_public_path__ + "img/quizz-step-11-3.52dbc9ea.jpg";